export function sessionStorageSupported() {
    let testStorage;
    try {
        window.sessionStorage.setItem('testKey', '1');
        window.sessionStorage.removeItem('testKey');
        testStorage = true;
    } catch (e) {
        testStorage = false;
    }
    return 'sessionStorage' in window && window['sessionStorage'] !== null && testStorage;
}

const supported = sessionStorageSupported();

export function getKey(key) {
    if (supported) {
        return window.sessionStorage.getItem(key);
    }
    return null;
}

export function getObject(key) {
    const value = getKey(key);
    return value === '' ? null : JSON.parse(value);
}

export function setKey(key, value) {
    if (supported) {
        window.sessionStorage.setItem(key, value);
    }
}

export function setObject(key, valueObject) {
    setKey(key, JSON.stringify(valueObject));
}

export function removeKey(key) {
    if (supported) {
        window.sessionStorage.removeItem(key);
    }
}
